<div class="control__wrapper bg-light">
    <div [ngClass]="{ 'control__shadow': control.elementVal.getValue()?.duringChange === 't' }"></div>
    <img class="control__img border-light"
         [ngClass]="{ 'bg-inactive': control.elementVal.getValue()?.duringChange === 't',
            'bg-style bg-style__icon': control.elementVal.getValue()?.duringChange !== 't' }"
         ngSrc="{{ setIcon(control.elementVal.getValue()?.iconId)}}"
         width="72" height="72" alt="" />
    <div class="control__img control__img--cover-wrapper"
         *ngIf="schedule.bgActive"
         (click)="schedule.closeInnerModal()">
        <div class="control__img control__img--cover"></div>
    </div>
    <h2 class="control__title"
        [ngClass]="{ 'bg-inactive': control.elementVal.getValue()?.duringChange === 't',
            'bg-style bg-style__label': control.elementVal.getValue()?.duringChange !== 't' }"
        *ngIf="control.elementVal.getValue()?.txtId > 0">
        {{ subtitle(control.elementVal.getValue()?.txtId) }}
    </h2>
    <h2 class="control__title"
        [ngClass]="{ 'bg-inactive': control.elementVal.getValue()?.duringChange === 't',
            'bg-style bg-style__label': control.elementVal.getValue()?.duringChange !== 't' }"
        *ngIf="control.elementVal.getValue()?.txtId === 0">
        {{ control.elementVal.getValue()?.params.dayId | weekDay }}
    </h2>
    <div class="control__content">
        <div [ngClass]="{
            'multiOnOff': control.elementVal.getValue()?.params.cols[0]['type'] === 28
                || control.elementVal.getValue()?.params.cols[0]['type'] === 29,
            'multi': (control.elementVal.getValue()?.params.cols?.[1]?.['type'] !== 28
                && control.elementVal.getValue()?.params.cols[0]['type'] > 0 ) || (
                    control.elementVal.getValue()?.params.cols[0]['type'] === -1
                ),
            'multi--only-step': control.elementVal.getValue()?.params.cols?.[1]?.['type'] !== 28
                && control.elementVal.getValue()?.params.cols[0]['type'] > 0,
            'multiTemp': control.elementVal.getValue()?.params.cols?.[1]?.['type'] === 6,
            'multi--only-temp': control.elementVal.getValue()?.params.cols[0]['type'] === -1 }">
            <div [ngClass]="{
                'multi--only-temp': control.elementVal.getValue()?.params.cols[0]['type'] < 0,
                'multi--only-step': control.elementVal.getValue()?.params.cols?.[1]?.['type'] < 0 }">
                <div class="multi__item">
                    <div class="color-basic font-bold border-dark-table"
                        [ngClass]="{ 'multiOnOff__name': control.elementVal.getValue()?.params.cols[0]['type'] === 28
                            || control.elementVal.getValue()?.params.cols[0]['type'] === 29,
                        'multi__name': !(control.elementVal.getValue()?.params.cols[0]['type'] === 28
                            || control.elementVal.getValue()?.params.cols[0]['type'] === 29) }">
                        {{ subtitle(2008) }}
                    </div>
                    <div class="color-basic font-bold border-dark-table"
                        [ngClass]="{
                        'multiOnOff__name': control.elementVal.getValue()?.params.cols[0]['type'] === 28
                            || control.elementVal.getValue()?.params.cols[0]['type'] === 29,
                        'multi__name': !(control.elementVal.getValue()?.params.cols[0]['type'] === 28
                            || control.elementVal.getValue()?.params.cols[0]['type'] === 29) }">
                        {{ subtitle(2009) }}
                    </div>
                    <div class="color-basic font-bold border-dark-table"
                        [ngClass]="{ 'multiOnOff__name': control.elementVal.getValue()?.params.cols[0]['type'] === 28
                            || control.elementVal.getValue()?.params.cols[0]['type'] === 29,
                        'multi__name': !(control.elementVal.getValue()?.params.cols[0]['type'] === 28
                            || control.elementVal.getValue()?.params.cols[0]['type'] === 29) }">
                        {{ subtitle(946) }}
                    </div>
                    <div *ngIf="control.elementVal.getValue()?.params.cols[0]['type'] >= 0"
                        class="color-basic font-bold border-dark-table"
                        [ngClass]="{ 'multiOnOff__name': control.elementVal.getValue()?.params.cols[0]['type'] === 28
                            || control.elementVal.getValue()?.params.cols[0]['type'] === 29,
                        'multi__name': !(control.elementVal.getValue()?.params.cols[0]['type'] === 28
                            || control.elementVal.getValue()?.params.cols[0]['type'] === 29) }">
                        {{ subtitle(control.elementVal.getValue()?.params.cols[0]['txtId']) }}
                    </div>
                    <div *ngIf="control.elementVal.getValue()?.params.cols[1] &&
                        control.elementVal.getValue()?.params.cols[1]['type'] >= 0"
                         class="color-basic font-bold border-dark-table"
                         [ngClass]="{ 'multiOnOff__name': control.elementVal.getValue()?.params.cols[0]['type'] === 28
                            || control.elementVal.getValue()?.params.cols[0]['type'] === 29,
                        'multi__name': !(control.elementVal.getValue()?.params.cols[0]['type'] === 28
                            || control.elementVal.getValue()?.params.cols[0]['type'] === 29) }">
                        {{ subtitle(control.elementVal.getValue()?.params.cols?.[1]?.['txtId']) }}
                    </div>
                </div>

                <div class="multi__item" *ngFor="let val of schedule.multiTable; let idx = index">
                    <div class="color-basic border-dark-table font-bold"
                        [attr.data-testid]="'from-' + idx"
                        [ngClass]="{ 'multiOnOff__start': control.elementVal.getValue()?.params.cols[0]['type'] === 28
                            || control.elementVal.getValue()?.params.cols[0]['type'] === 29,
                            'multi__start': !(control.elementVal.getValue()?.params.cols[0]['type'] === 28
                            || control.elementVal.getValue()?.params.cols[0]['type'] === 29) }"
                        (click)="control.elementVal.getValue()?.params.type === 1
                            ? schedule.getNonAdjacentIntervals(schedule.multiTable[idx].startTime,
                                val.endTime, idx,'start',
                                control.elementVal.getValue()?.params.cols[0]['type'])
                            : schedule.getAdjacentIntervals(schedule.multiTable[idx-1]?.startTime ?? 0, val.endTime, idx,'start')">
                        <ng-container *ngIf="hasAdjacentValues">
                            <p *ngIf="idx !== schedule.multiTable.length -1">
                                {{ (idx === 0 ? 0 : startValue[idx]) * 3 | quarter }}</p>
                            <p *ngIf="idx === schedule.multiTable.length -1">
                                {{ startValue[idx] * 3 | quarter }}
                            </p>
                        </ng-container>
                        <ng-container *ngIf="hasNonAdjacentValues">
                            <p>
                                {{ startValue[idx] * 3 | quarter }}
                            </p>
                        </ng-container>
                        <div class="multi__time-list bg-light cursor-pointer" *ngIf="val.range && val.range.length > 0">
                            <div *ngIf="control.elementVal.getValue()?.params.type === 1">
                                <p class="multi__time-list-item font-bold"
                                   *ngFor="let value of val.range"
                                   [ngClass]="{ 'bg-recuperator color-light': value == val.active }"
                                   data-testid="timeValue-1"
                                   (click)="schedule.setNonAdjacentIntervals(idx, value, control.elementVal.getValue()?.params.cols[0]['type']);
                                        $event.stopPropagation();">
                                    {{ value | quarter }}
                                </p>
                            </div>
                            <div *ngIf="control.elementVal.getValue()?.params.type === 0">
                                <p class="multi__time-list-item font-bold"
                                   *ngFor="let value of val.range"
                                   [ngClass]="{ 'bg-recuperator color-light': value === val.active }"
                                   data-testid="timeValue-0"
                                   (click)="schedule.setAdjacentIntervals(idx, value); $event.stopPropagation();">
                                   {{ value | quarter }}
                                </p>
                            </div>
                        </div>
                    </div>

                    <div class="color-basic border-dark-table font-bold"
                        [attr.data-testid]="'to-' + idx"
                        [ngClass]="{ 'multiOnOff__end': control.elementVal.getValue()?.params.cols[0]['type'] === 28
                            || control.elementVal.getValue()?.params.cols[0]['type'] === 29,
                            'multi__start': !(control.elementVal.getValue()?.params.cols[0]['type'] === 28
                        || control.elementVal.getValue()?.params.cols[0]['type'] === 29) }"
                        (click)="control.elementVal.getValue()?.params.type === 1
                            ? schedule.getNonAdjacentIntervals(val.startTime,
                                schedule.multiTable[idx].endTime, idx,'end',
                                control.elementVal.getValue()?.params.cols[0]['type'])
                            : schedule.getAdjacentIntervals(val.startTime,
                                schedule.multiTable[idx+1]?.endTime ?? 1439, idx,'end')">
                        <ng-container *ngIf="hasAdjacentValues">
                            <p *ngIf="idx !== schedule.multiTable.length -1">
                                {{ (idx === 0 ? startValue[idx] : endValue[idx]) * 3 | quarter }}
                            </p>
                            <p *ngIf="idx === schedule.multiTable.length -1">
                                {{ 1439 | quarter }}
                            </p>
                        </ng-container>
                        <ng-container *ngIf="hasNonAdjacentValues">
                            <p>
                                {{ (endValue[idx] === 480 ? 1439 : endValue[idx] * 3) | quarter }}
                            </p>
                        </ng-container>
                    </div>

                    <div class="border-dark-table"
                        [attr.data-testid]="'slider-' + idx"
                        *ngIf="control.elementVal.getValue()?.params.type === 1">
                        <div class="custom-slider">
                            <ngx-slider
                                [(value)]="startValue[idx]"
                                [(highValue)]="endValue[idx]"
                                [options]="options[idx]"
                                (userChange)="changeNonAdjacentValues($event, idx)"
                                (valueChange)="onValueChange($event, idx)"
                                (userChangeEnd)="changeNonAdjacentValuesEnd($event, idx)">
                            </ngx-slider>
                        </div>
                    </div>

                    <div class="border-dark-table"
                         [attr.data-testid]="'slider-' + idx"
                         *ngIf="control.elementVal.getValue()?.params.type === 0">
                        <div class="custom-slider">
                            <ngx-slider *ngIf="idx === 0"
                                [(value)]="startValue[idx]"
                                [options]="options[idx]"
                                (userChange)="changeAdjacentValues($event, idx)"
                                (valueChange)="onValueChange($event, idx)"
                                (userChangeEnd)="changeValuesEnd($event, idx)">
                            </ngx-slider>
                            <ngx-slider
                                *ngIf="idx !== 0 && idx !== schedule.multiTable.length - 1"
                                [(value)]="startValue[idx]"
                                [(highValue)]="endValue[idx]"
                                [options]="options[idx]"
                                (userChange)="changeAdjacentValues($event, idx)"
                                (valueChange)="onValueChange($event, idx)"
                                (userChangeEnd)="changeValuesEnd($event, idx)">
                            </ngx-slider>
                            <ngx-slider *ngIf="idx === schedule.multiTable.length - 1"
                                [(value)]="startValue[idx]"
                                [options]="options[idx]"
                                (userChange)="changeAdjacentValues($event, idx)"
                                (valueChange)="onValueChange($event, idx)"
                                (userChangeEnd)="changeValuesEnd($event, idx)">
                            </ngx-slider>
                        </div>
                    </div>

                    <div class="multi__level color-basic border-dark-table"
                         *ngIf="control.elementVal.getValue()?.params.cols[0]['type'] !== 28
                            && control.elementVal.getValue()?.params.cols[0]['type'] !== 29
                            && control.elementVal.getValue()?.params.cols[0]['type'] >= 0 ">
                        <div class="multi__level-item cursor-pointer"
                             [ngClass]="{ 'bg-recuperator':val.valueFirstColumn >=1,
                                'bg-grey': !(val.valueFirstColumn >=1) }"
                             [attr.data-testid]="'gear1-' + idx"
                             (click)="val.valueFirstColumn = (val.valueFirstColumn > 1 || val.valueFirstColumn == 0 ) ? 1 : 0">
                        </div>
                        <div class="multi__level-item cursor-pointer"
                             [ngClass]="{ 'bg-recuperator': val.valueFirstColumn >=2,
                                'bg-grey': !(val.valueFirstColumn >=2) }"
                             [attr.data-testid]="'gear2-' + idx"
                             (click)="val.valueFirstColumn=2">
                        </div>
                        <div class="multi__level-item cursor-pointer"
                            [ngClass]="{ 'bg-recuperator': val.valueFirstColumn >=3,
                                'bg-grey': !(val.valueFirstColumn >=3) }"
                             [attr.data-testid]="'gear3-' + idx"
                             (click)="val.valueFirstColumn=3">
                        </div>
                    </div>

                    <div class="multi__level color-basic border-dark-table"
                        *ngIf="control.elementVal.getValue()?.params.cols[0]['type'] === 28
                            || control.elementVal.getValue()?.params.cols[0]['type'] == 29">
                        <div class="multi__level-item multi__level-item--on-off cursor-pointer"
                             [attr.data-testid]="'firstColumn-' + idx"
                             [ngClass]="{ 'bg-active': val.valueFirstColumn >=1,
                                'bg-red': !(val.valueFirstColumn >=1) }"
                             (click)="val.valueFirstColumn = (val.valueFirstColumn > 1 || val.valueFirstColumn == 0 ) ? 1 : 0">
                        </div>
                    </div>

                    <div class="multi__temp color-basic border-dark-table"
                        [attr.data-testid]="'secondColumn-' + idx"
                        *ngIf="control.elementVal.getValue()?.params.cols[1]
                        && control.elementVal.getValue()?.params.cols[1]?.['type'] >= 0">
                        <p class="multi__temp-element color-light bg-recuperator cursor-pointer"
                           [attr.data-testid]="'temp-' + idx"
                           (click)="tempVal = val.valueSecondColumn; schedule.showMultiTempRange(idx)">
                            {{ val.valueSecondColumn | format:control.elementVal.getValue()?.params.cols[1]?.['type'] }}
                        </p>
                    </div>

                    <div *ngIf="control.elementVal.getValue()?.params.cols[0]['type'] === 28
                        || control.elementVal.getValue()?.params.cols[0]['type'] === 29">
                        <div class="multi__level multi__level-small bg-light"
                            *ngIf="schedule.tempSet == idx">
                            <div class="multi__level-item multi__level-item--on-off multiOnOff__level-small-item cursor-pointer"
                                [ngClass]="{ 'bg-active': val.valueFirstColumn >=1,
                                    'bg-red': !(val.valueFirstColumn >=1) }"
                                (click)="val.valueFirstColumn = (val.valueFirstColumn > 1 || val.valueFirstColumn == 0 ) ? 1 : 0;
                                    schedule.showHideBg()">
                            </div>
                        </div>
                    </div>

                    <div *ngIf="control.elementVal.getValue()?.params.cols[0]['type'] !== 28
                        && control.elementVal.getValue()?.params.cols[0]['type'] !== 29">
                        <div class="multi__level multi__level-small bg-light"
                            *ngIf="schedule.tempSet == idx">
                            <div class="multi__level-item multi__level-small-item cursor-pointer"
                                 [ngClass]="{ 'bg-recuperator': val.valueFirstColumn >=1,
                                    'bg-grey': !(val.valueFirstColumn >=1) }"
                                 [attr.data-testid]="'gear1-' + idx"
                                 (click)="val.valueFirstColumn = (val.valueFirstColumn > 1 || val.valueFirstColumn == 0 ) ? 1 : 0;
                                      schedule.showHideBg()">
                            </div>
                            <div class="multi__level-item multi__level-small-item cursor-pointer"
                                [ngClass]="{ 'bg-recuperator': val.valueFirstColumn >=2,
                                    'bg-grey': !(val.valueFirstColumn >=2) }"
                                 [attr.data-testid]="'gear2-' + idx"
                                 (click)="val.valueFirstColumn=2; schedule.showHideBg()"></div>
                            <div class="multi__level-item multi__level-small-item cursor-pointer"
                                [ngClass]="{ 'bg-recuperator': val.valueFirstColumn >=3,
                                    'bg-grey': !(val.valueFirstColumn >=3) }"
                                [attr.data-testid]="'gear3-' + idx"
                                (click)="val.valueFirstColumn=3;
                                 schedule.showHideBg()">
                            </div>
                        </div>
                    </div>

                    <div class="multi__temp-bg"
                         [ngClass]="{ 'multi__temp-bg--show': val.isVisible }"
                         *ngIf="control.elementVal.getValue()?.params.numCols > 1">
                        <div class="multi__temp-range bg-light"
                            [attr.data-testid]="'innerControl-' + idx">
                            <div class="bg-lite ">
                                <div class="control__range">
                                    <div class="control__value  font-55 font-bold color-style"
                                        [attr.data-testid]="'tempValue-' + idx">
                                         {{ tempVal | format:control.elementVal.getValue()?.params.cols[1]['type'] }}
                                    </div>
                                    <div class="control__min color-basic font-14">
                                        <p>
                                            <span>{{ subtitle(395) }}</span>
                                            <span>{{ control.elementVal.getValue()?.params.cols[1]['min']
                                                | format:control.elementVal.getValue()?.params.cols[1]['type'] }}
                                            </span>
                                        </p>
                                    </div>
                                    <div class="control__max color-basic font-14">
                                        <p><span>{{ subtitle(1064) }}</span>
                                            <span>{{ control.elementVal.getValue()?.params.cols[1]['max']
                                                | format:control.elementVal.getValue()?.params.cols[1]['type'] }}
                                            </span>
                                        </p>
                                    </div>
                                    <input class="control__input-range cursor-pointer"
                                        [attr.data-testid]="'tempSlider-' + idx"
                                        type="range"
                                        [(ngModel)]="tempVal"
                                        min="{{ control.elementVal.getValue()?.params.cols[1]['min'] }}"
                                        max="{{ control.elementVal.getValue()?.params.cols[1]['max'] }}"
                                        step="{{ control.elementVal.getValue()?.params.cols[1]['interval'] }}">
                                    <div class="control__remove cursor-pointer"
                                        [attr.data-testid]="'minusButton-' + idx">
                                        <hold-wrapper (onAction)="tempVal = schedule.smallRangeMinusVal(
                                                tempVal,
                                                control.elementVal.getValue()?.params.cols[1]['min'],
                                                control.elementVal.getValue()?.params.cols[1]['interval']
                                            )">
                                            <img ngSrc="/assets/img/icons/minus.svg"
                                                 width="40" height="40" alt="" />
                                        </hold-wrapper>
                                    </div>
                                    <div class="control__add cursor-pointer"
                                        [attr.data-testid]="'plusButton-' + idx">
                                        <hold-wrapper (onAction)="tempVal = schedule.smallRangePlusVal(
                                                tempVal,
                                                control.elementVal.getValue()?.params.cols[1]['max'],
                                                control.elementVal.getValue()?.params.cols[1]['interval']
                                            )">
                                            <img ngSrc="/assets/img/icons/plus.svg"
                                                 width="40" height="40" alt="" />
                                        </hold-wrapper>
                                    </div>
                                </div>
                            </div>
                            <div class="control__group-btn">
                                <button class="control__button bg-default bg-default__button"
                                        [attr.data-testid]="'closeButton-' + idx"
                                        (click)="schedule.closeInnerModal()">
                                    <img class="control__button-img"
                                         ngSrc="/assets/img/zone_icons/back.svg"
                                         width="40" height="40" alt="" />
                                </button>
                                <button class="control__button bg-ok bg-ok--accept"
                                        [attr.data-testid]="'okButton-' + idx"
                                        (click)="val.isVisible=false;
                                        val.valueSecondColumn = tempVal;
                                        schedule.tempRange = false;
                                        schedule.showHideBg();">
                                    <img class="control__button-img"
                                         ngSrc="/assets/img/icons/ok.svg"
                                         width="40" height="40" alt="" />
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <ng-container *ngIf="control.brotherElement">
            <div class="control__checkbox-weekday"
                *ngFor="let value of control.brotherElement.sort(sortById)">
                <label class="color-basic cursor-pointer">
                    <span class="control__checkbox-weekday-name"
                        [ngClass]="{ 'font-bold': value.id === control.elementVal.getValue()?.id }">
                        {{ value.params.dayId | weekDay }}
                    </span>
                    <input class="control__checkbox-weekday-input cursor-pointer"
                        type="checkbox"
                        [disabled]="value.id === control.elementVal.getValue()?.id"
                        [(ngModel)]="value.checked" />
                </label>
            </div>
        </ng-container>
    </div>

    <div class="control__group-btn"
        *ngIf="control.elementVal.getValue()?.params.cols[0]['type'] !== 28
            && control.elementVal.getValue()?.params.cols[0]['type'] !== 29">
        <button class="control__button bg-default bg-default__button control__button--shadow-active"
            data-testid="goBackButton"
            (click)="control.hideControl()">
            <img class="control__button-img"
                ngSrc="/assets/img/zone_icons/back.svg"
                width="40" height="40" alt="" />
        </button>
        <button class="control__button control__button--small bg-default"
            data-testid="resetButton"
            (click)="schedule.multiTableSetDefault();setMultiTable();">
            <img class="control__button-img"
                ngSrc="/assets/img/icons/return.svg"
                width="40" height="40" alt="" />
        </button>
        <button class="control__button"
            [ngClass]="{ 'bg-default': control.elementVal.getValue()?.duringChange === 't',
                'bg-ok': control.elementVal.getValue()?.duringChange === 'f',
                'bg-ok--accept': control.elementVal.getValue()?.duringChange === 'f' }"
                data-testid="sendButton"
                (click)="schedule.returnMultiTable()">
            <img class="control__button-img"
                 ngSrc="/assets/img/icons/ok.svg"
                 width="40" height="40" alt="" />
        </button>
    </div>

    <div class="control__group-btn"
        *ngIf="control.elementVal.getValue()?.params.cols[0]['type'] === 28
            || control.elementVal.getValue()?.params.cols[0]['type'] === 29">
        <button class="control__button bg-default bg-default__button control__button--shadow-active"
            data-testid="goBackButton"
            (click)="control.hideControl()">
            <img class="control__button-img"
                ngSrc="/assets/img/zone_icons/back.svg"
                width="40" height="40" alt="" />
        </button>
        <button class="control__button control__button--small bg-default"
            data-testid="resetButton"
            (click)="schedule.multiTableSetDefault();setMultiTable();">
            <img class="control__button-img"
                ngSrc="/assets/img/icons/return.svg"
                width="40" height="40" alt="" />
        </button>
        <button class="control__button"
            [ngClass]="{ 'bg-default': control.elementVal.getValue()?.duringChange === 't',
                'bg-ok': control.elementVal.getValue()?.duringChange === 'f',
                'bg-ok--accept': control.elementVal.getValue()?.duringChange === 'f' }"
                data-testid="sendButton"
                (click)="schedule.returnMultiTableOnOff()">
            <img class="control__button-img"
                 ngSrc="/assets/img/icons/ok.svg"
                 width="40" height="40" alt="" />
        </button>
    </div>

    <div *ngIf="control.elementVal.getValue()?.duringChange === 't'"
         class="control__during-change">
        <p class="color-alarm font-18">{{ subtitle(3162) }}</p>
    </div>
</div>

<div class="multi__time-list-wrapper color-basic bg-shadow" *ngIf="schedule.bgActive"
     (click)="schedule.closeInnerModal()">
</div>
